import { StatusSelect, type StatusSelectProps } from './StatusSelect'
import { StatusBadge } from './StatusBadge'
import { toast } from 'react-toastify'

export type StatusCellProps = Pick<
    StatusSelectProps,
    'value' | 'onChange' | 'documentType'
> & {
    className?: string
    actDate?: Date
}

export const StatusCell = ({
    value,
    onChange,
    documentType,
    className,
    actDate,
}: StatusCellProps) => {
    const shouldShowBadgeOnly =
        (documentType === 'act' && value === 'formed') ||
        value === 'waiting_to_load'

    const formattedDate = actDate
        ? new Date(actDate).toLocaleDateString('ru-RU', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
          })
        : ''

    const showToaster =
        value === 'waiting_to_load' &&
        `Акт будет передан в ОРД ${formattedDate}`

    return shouldShowBadgeOnly ? (
        <StatusBadge
            className={className}
            value={value}
            showToaster={showToaster}
            onClick={() => toast.success(showToaster)}
        />
    ) : (
        <StatusSelect
            value={value}
            onChange={onChange}
            documentType={documentType}
            classNameTrigger={className}
            classNameContent={'w-[139px]'}
        />
    )
}
